export class PreferenceFacturation {
  public id: number;
  public titre: string;
  public nomOrganisme: string;
  public classeProfit: string;
  public siret: string;
  public typeEntite: string;
  public identifiantAdressage: string;
  public refBonCommande: string;
  public noExecutant: string;
  public noEngagementJuridique: string;
  public serviceOuDestinataire: string;
  public immeuble: string;
  public voieAdresse: string;
  public complement: string;
  public codePostal: string;
  public pays: any;
  public tva: string;
  public ville: string;

}

export enum PreferenceFacturationEnum {
  // Structure utilisée pour stocker / charger les informations de préférences en base
  NO_EXECUTANT = 'noServiceExecutant',
  CLASSE_PROFIT = 'classeProfit',
  BON_COMMANDE = 'numBonCommande', // Point d'attention stocke Bon de commande Et Engagement Juridique
  NOM_ORGANISME = 'denomination',
  SIRET = 'siret',
  TYPE_ENTITE = 'typeEntite',
  IDENTIFIANT_ADRESSAGE = 'identifiantAdressage',
  ADR1 = 'adr1',
  ADR2 = 'adr2',
  ADR3 = 'adr3',
  ADR4 = 'adr4',
  CP = 'cp',
  VILLE = 'ville',
  PAYS = 'pays',
  TVA = 'tvaIntracommunautaire'
}
